import * as Actions from '../actions/index';

const initialState = {
  options: [],
  grades: {},
  courseGradeGoalsProgressCurrentWeek: null,
};

export default function courseGrades(state = initialState, action) {
  switch (action.type) {
    case Actions.LOAD_COURSE_GOAL_OPTIONS:
      return {
        ...state,
        options: action.courseGoalOptions,
      };
    case Actions.LOAD_COURSE_GRADES: {
      const courseId = action.courseId;
      const courseGrades = action.courseGrades;

      const stateCourseGrades = JSON.parse(JSON.stringify(state.grades));
      stateCourseGrades[courseId] = courseGrades;

      return {
        ...state,
        grades: stateCourseGrades,
      };
    }
    case Actions.UPDATE_COURSE_GRADES: {
      const courseId = action.courseId;
      const courseGrades = action.courseGrades;

      const stateCourseGrades = JSON.parse(JSON.stringify(state.grades));
      stateCourseGrades[courseId] = courseGrades;

      if (courseGrades.calculateGrades) {
        stateCourseGrades[courseId].evaluatingGrades = new Date();
      }

      return {
        ...state,
        grades: stateCourseGrades,
      };
    }
    case Actions.UPDATE_SETTING_FOR_STUDENT: {
      const courseId = action.courseId;
      const showGradesToStudents = action.showGradesToStudents;

      const stateCourseGrades = JSON.parse(JSON.stringify(state.grades));
      const courseGrades = stateCourseGrades[courseId];

      if (courseGrades) {
        courseGrades.showGradesToStudents = showGradesToStudents;
      }

      return {
        ...state,
        grades: stateCourseGrades,
      };
    }
    case Actions.LOAD_COURSE_GRADE_GOALS_PROGRESS_CURRENT_WEEK: {
      return {
        ...state,
        courseGradeGoalsProgressCurrentWeek:
          action.courseGradeGoalsProgressCurrentWeek,
      };
    }
    default:
      return state;
  }
}
